class VariantThumbsController {
  constructor() {
    this.thumbSelector = '.product__thumb-item';
    this.inputSelector = 'input[data-variant-input][type="radio"]';
    this.knownColorKeys = ['color', 'culoare', 'colours', 'colors', 'farbe', 'couleur', 'CULOARE'];
    this.knownMetalKeys = ['metalware/personalizare', 'metal', 'hardware', 'METALWARE/PERSONALIZARE'];
    this._allMainSlides = null;
    this._validSlidePositions = new Set();
    this._flickityGuardSetup = false;

    document.addEventListener('DOMContentLoaded', () => this.init());
  }

  init() {
    const variant = this.getCurrentVariantHandle();
    if (!variant) return;

    this.showVariantThumbs(variant);
    this.attachVariantChangeListener();
    this.listenToCustomEvent();
    this.hideDotsForHiddenThumbs();
    this.setupFlickityGuard();
  }

  handleize(str) {
    if (!str) return '';
    return str.toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .trim();
  }

  getCurrentVariantHandle() {
    const inputs = document.querySelectorAll(this.inputSelector);
    let colorValue = null;
    let metalValue = null;

    for (const input of inputs) {
      if (!input.checked) continue;
      const name = input.name?.toLowerCase();
      if (this.knownColorKeys.includes(name)) colorValue = input.value;
      if (this.knownMetalKeys.includes(name)) metalValue = input.value;
    }

    if (!colorValue) return null;

    const handleColor = this.handleize(colorValue);
    const handleMetal = metalValue ? this.handleize(metalValue) : null;
    return handleMetal ? `${handleColor}-${handleMetal}` : handleColor;
  }

  showVariantThumbs(variantHandle) {
    const validIndices = new Set();

    document.querySelectorAll(this.thumbSelector).forEach(item => {
      const variant = item.getAttribute('data-variant');
      const isVisible = variant === variantHandle;
      item.style.display = isVisible ? '' : 'none';
      if (isVisible) validIndices.add(item.getAttribute('data-index'));
    });

    this.syncMainSlides(validIndices);
    this.hideDotsForHiddenThumbs();
  }

  syncMainSlides(validIndices) {
    if (!this._allMainSlides) {
      this._allMainSlides = [...document.querySelectorAll('.product-main-slide')];
    }

    this._validSlidePositions = new Set();

    this._allMainSlides.forEach((slide, position) => {
      const dataIndex = slide.getAttribute('data-index');
      if (validIndices.has(dataIndex)) {
        slide.removeAttribute('data-variant-hidden');
        this._validSlidePositions.add(position);
      } else {
        slide.setAttribute('data-variant-hidden', '');
      }
    });

    const flkty = this._getFlickity();
    if (flkty && this._validSlidePositions.size > 0) {
      const firstValid = Math.min(...this._validSlidePositions);
      flkty.select(firstValid, false, true);
    }
  }

  setupFlickityGuard() {
    this._trySetupFlickityGuard();
    document.addEventListener('variantImageDefaultCustomization', () => {
      this._trySetupFlickityGuard();
    }, { once: true });
  }

  _trySetupFlickityGuard() {
    if (this._flickityGuardSetup) return;
    const flkty = this._getFlickity();
    if (!flkty) return;
    this._flickityGuardSetup = true;

    flkty.on('change', (index) => {
      if (this._validSlidePositions.has(index)) return;
      const valid = [...this._validSlidePositions];
      if (valid.length === 0) return;
      const nearest = valid.reduce((prev, curr) =>
        Math.abs(curr - index) < Math.abs(prev - index) ? curr : prev
      );
      flkty.select(nearest, false, true);
    });
  }

  _getFlickity() {
    const sliderEl = document.querySelector('[data-product-photos]');
    return (sliderEl && window.Flickity) ? Flickity.data(sliderEl) : null;
  }

  attachVariantChangeListener() {
    document.querySelectorAll(this.inputSelector).forEach(input => {
      input.addEventListener('change', () => {
        const colorHandle = this.getColorHandle();
        const metalHandle = this.handleize(this.getSelectedMetalware());

        if (colorHandle && metalHandle) {
          this.showVariantThumbs(`${colorHandle}-${metalHandle}`);
        } else if (colorHandle) {
          this.showVariantThumbs(colorHandle);
        }
      });
    });
  }

  listenToCustomEvent() {
    document.addEventListener('variantImageDefaultCustomization', e => {
      const index = e.detail?.index;
      const thumb = document.querySelector(`${this.thumbSelector}[data-index="${index}"]`);
      const variantName = thumb?.getAttribute('data-variant');
      if (variantName) {
        this.showVariantThumbs(variantName);
      }
    });
  }

  hideDotsForHiddenThumbs() {
    const thumbs = document.querySelectorAll(this.thumbSelector);
    const dots = document.querySelectorAll('.flickity-page-dots .dot');

    thumbs.forEach((thumb, index) => {
      const dot = dots[index];
      if (!dot) return;
      dot.style.display = thumb.style.display === 'none' ? 'none' : '';
    });
  }

  getSelectedMetalware() {
    const metalInputs = document.querySelectorAll('fieldset[data-index="option2"] input[type="radio"]');
    for (const input of metalInputs) {
      if (input.checked) return input.value;
    }
    return null;
  }

  getColorHandle() {
    const inputs = document.querySelectorAll(this.inputSelector);
    for (const input of inputs) {
      if (!input.checked) continue;
      const name = input.name?.toLowerCase();
      if (this.knownColorKeys.includes(name)) {
        return this.handleize(input.value);
      }
    }
    return null;
  }
}

new VariantThumbsController();
